export const DEFAULT_ERROR: any = {
  face: "Khuôn mặt không hợp lệ với khuôn mặt đã đăng ký",
  concentration: "Không tập trung vào bài thi",
  position: "Rời vị trí",
};
